'use strict';

module.exports = function (Chart) {
  Chart.PolarArea = function (context, config) {
    config.type = 'polarArea';
    return new Chart(context, config);
  };
};